import { updateValues } from "../../../config/firebase";

const createRequest = async (sessionInvoices, projects, setWrittenRequests) => {
  const localStorageData = JSON.parse(localStorage.getItem("User"));
  const userId = localStorageData.firmId;
  const totalInvoices = sessionInvoices.length;
  let completedRequests = 0;
  let failedRequests = 0;

  // Process requests in parallel with proper error handling
  const requestPromises = sessionInvoices.map(async (invoice, index) => {
    try {
      // Update progress status before starting each request
      setWrittenRequests((prev) => ({
        ...prev,
        current: completedRequests + failedRequests + 1,
        total: totalInvoices,
        status: `Starting request ${
          completedRequests + failedRequests + 1
        }/${totalInvoices}...`,
      }));

      let targetProject =
        (await projects.find(
          (project) =>
            project.projectName ===
            invoice.requestItemData.projectName.split("-")[0]
        )) || null;

      if (targetProject !== null) {
        // Create request in existing project
        await updateValues(
          "POST",
          `${targetProject.firmDetailsID}/MRNRequest/${targetProject.projectID}/${invoice.requestItemData.poNumber}/`,
          invoice.requestItemData,
          true
        );
      } else {
        // Create new project and request
        let newProjectId = new Date().getTime();
        // let allProjectUsers = await updateValues('GET', `${projects[0].firmDetailsID}/projectsUserDetails/`)
        await updateValues(
          "POST",
          `userDetails/${userId}/projects/${newProjectId}`,
          {
            firmDetailsID: projects[0].firmDetailsID,
            firmName: projects[0].firmName,
            lastOpen: newProjectId,
            projectAdress: projects[0].projectAdress,
            projectID: newProjectId,
            projectName: invoice.requestItemData.projectName.split("-")[0],
            role: "Admin",
          },
          true
        );
        await updateValues(
          "POST",
          `${projects[0].firmDetailsID}/MRNRequest/${newProjectId}/${invoice.requestItemData.poNumber}/`,
          invoice.requestItemData,
          true
        );
      }

      completedRequests++;
      // Update progress after successful completion
      setWrittenRequests((prev) => ({
        ...prev,
        current: completedRequests + failedRequests,
        total: totalInvoices,
        status: `Completed request ${
          completedRequests + failedRequests
        }/${totalInvoices}...`,
      }));

      return { success: true, invoice };
    } catch (error) {
      console.error(`Error creating request for ${invoice.name}:`, error);
      failedRequests++;
      // Update progress after failure
      setWrittenRequests((prev) => ({
        ...prev,
        current: completedRequests + failedRequests,
        total: totalInvoices,
        status: `Failed request ${
          completedRequests + failedRequests
        }/${totalInvoices}: ${error.message}`,
      }));
      return { success: false, invoice, error };
    }
  });

  try {
    // Process all requests and collect results
    const results = await Promise.all(requestPromises);

    // Count successes and failures
    const successfulRequests = results.filter((r) => r.success).length;
    const failedRequests = results.filter((r) => !r.success).length;

    // Final status
    if (failedRequests > 0) {
      setWrittenRequests((prev) => ({
        ...prev,
        status: `Created ${successfulRequests}/${totalInvoices} requests (${failedRequests} failed)`,
      }));
    } else {
      setWrittenRequests((prev) => ({
        ...prev,
        status: `Successfully created all ${totalInvoices} requests`,
      }));
    }

    // Log results for debugging
    console.log("Request creation results:", {
      total: totalInvoices,
      successful: successfulRequests,
      failed: failedRequests,
      details: results,
    });
  } catch (error) {
    console.error("Error during request creation:", error);
    setWrittenRequests((prev) => ({
      ...prev,
      status: `Error creating requests: ${error.message}`,
    }));
  }
};

export default createRequest;
